module.exports = __webpack_public_path__ + "static/media/blue-up-arrow.svg.05ab674e.svg";